export var accordionVariables = function accordionVariables(siteVars) {
  return {
    color: siteVars.bodyColor,
    focusBorderColor: siteVars.focusOuterBorderColor,
    focusBorderRadius: siteVars.borderRadiusMedium,
    focusBorderWidth: siteVars.borderWidth
  };
};